import RestResource from '../rest.service';
import Service from '../api.service';

export default class PlotsService extends RestResource {
  map(payload) {
    const plot = {
      field_id: payload.field.id,
      name: payload.name,
      hectares: payload.hectares,
      grooves_distance: payload.groovesDistance,
      campaign_id: payload.campaign,
      predecessor_id: payload.predecessor,
      variety_id: payload.variety,
      latitude: payload.latitude,
      longitude: payload.longitude,
      plot_type_id: payload.plotType,
    };

    if (payload.coordinates.length > 0) {
      plot.coordinates = payload.coordinates;
    }

    return plot;
  }

  getPdf(id, filename) {
    return Service.get(this.pdfResource(id), { responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }

  constructor() {
    super('plots');
  }
}
